module.exports = __webpack_public_path__ + "fonts/ca3c05a931d5c1292770be28b3df7a21.svg";